import { render, staticRenderFns } from "./upcomingsessionDetail.vue?vue&type=template&id=1274f29e&scoped=true&"
import script from "./upcomingsessionDetail.vue?vue&type=script&lang=js&"
export * from "./upcomingsessionDetail.vue?vue&type=script&lang=js&"
import style0 from "./upcomingsessionDetail.vue?vue&type=style&index=0&id=1274f29e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274f29e",
  null
  
)

export default component.exports